module.exports = __webpack_public_path__ + "static/media/wordpress.70dfbaad.svg";